module.exports = __webpack_public_path__ + "static/media/remove_new.8d64d5c2.svg";